/* eslint-disable @typescript-eslint/no-var-requires */

export const commonEnvironment = {
  // eslint-disable-next-line @nx/enforce-module-boundaries
  version: require('../../../../package.json').version,
  appKeyword: 'management-app',
};
